import React, { useState, useCallback } from "react";
import { SManagement } from "../../ReusableComponents/CommonApis";
import { useDropzone } from "react-dropzone";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import axiosInstance from "../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { MdFileDownload } from "react-icons/md";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { RiFileExcel2Fill } from "react-icons/ri";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegEdit, FaRegSave } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import InternetChecking from "../../Student/Reusablecomponents/Network";

const SchoolBulk = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);

    const [SFName, SetSFName] = useState("");
    const [ValidRecords, SetValidRecords] = useState();
    const [InValidRecords, SetInValidRecords] = useState();
    const [SchoolMDetails, SetSchoolMDetails] = useState({
        SchoolManagement: "",
        Boardofexam: "",
    });
    const [Finialrecords, SetFinialrecords] = useState([]);
    // const [SchoolErrors, SetSchoolErrors] = useState({});

    const [EditingRow, SetEditingRow] = useState(null);
    const [EditForm, SetEditForm] = useState({});

    const StoreDetails = (e, Name) => {
        SetSchoolMDetails({ ...SchoolMDetails, [e.target?.name || Name]: e });
    };

    const ActuallHeader = ["S.No", "School UDISE", "School Name", "District", "School Loacation Rural / Urban",
        "City", "Contact name", "Contact number", "Email ID", "Address", "Pincode", "Medium of Instruction"];
    const validateHeader = (headerRow, expectedHeader) => {
        return JSON.stringify(headerRow) === JSON.stringify(expectedHeader);
    };
    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length > 0) {
            alert("Only .xls and .xlsx files are allowed");
            return;
        }
        const file = acceptedFiles[0];
        SetSFName(file?.name);
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
            const isHeaderValid = validateHeader(headers, ActuallHeader);
            if (!isHeaderValid) {
                alert("Invalid header in Excel file. Please check the file and try again.");
                SetSFName("")
                return "";
            }
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            const XLDATA = jsonData?.map((row, index) => ({
                RowID: index,
                UDISE: row?.["School UDISE"],
                SchoolName: row?.["School Name"]?.trim(),
                SchoolManagement: row?.["School Management"]?.trim(),
                District: row?.District?.trim(),
                SLocation: row?.["School Loacation Rural / Urban"]?.trim(),
                City: row?.City?.trim(),
                CName: row?.["Contact name"]?.trim(),
                PNumber: row?.["Contact number"],
                EMail: row?.["Email ID"]?.trim(),
                Address: row?.Address?.trim(),
                Pincode: row?.Pincode,
                MOI: row?.["Medium of Instruction"]?.trim(),
            }))
            const validRecords = [];
            const invalidRecords = [];
            // const schoolNameMap = new Map();
            const udiseMap = new Map();
            for (let i = 0; i < XLDATA.length; i++) {
                const currentRecord = XLDATA[i];
                try {
                    await validationSchema.validate(currentRecord, { abortEarly: false });
                    const errors = [];
                    // const schoolName = currentRecord?.SchoolName?.trim()?.toLowerCase();
                    const udise = currentRecord?.UDISE?.toString()?.trim();
                    // if (schoolName) {
                    //     if (schoolNameMap.has(schoolName)) {
                    //         errors.push({ field: "SchoolName", message: "Duplicate School Name" });
                    //     } else {
                    //         schoolNameMap.set(schoolName, i);
                    //     }
                    // }

                    if (udise) {
                        if (udiseMap.has(udise)) {
                            errors.push({ field: "UDISE", message: "Duplicate School UDISE Code" });
                        } else {
                            udiseMap.set(udise, i);
                        }
                    }
                    if (errors.length > 0) {
                        invalidRecords.push({
                            ...currentRecord,
                            Duplicate: true,
                            errors: errors.map((error) => ({
                                field: error.path,
                                message: error.message
                            }))
                        });
                    } else {
                        const apiResponse = await CheckSchoolDetails(currentRecord?.SchoolName, currentRecord?.UDISE, currentRecord?.District);
                        if (apiResponse?.isSchoolExist === 1 || apiResponse?.districtId === 0) {
                            invalidRecords.push({
                                ...currentRecord,
                                Duplicate: apiResponse?.isSchoolExist === 1 ? true : false,
                                errors: [apiResponse?.isSchoolExist === 1 ? { field: "Inserted", message: "School Already Exists" } : apiResponse?.districtId === 0 ? { field: "District", message: "Invalid District" } : {}]
                            });
                        } else if (apiResponse?.isSchoolExist === 0 && apiResponse?.districtId !== 0) {
                            validRecords.push({ ...currentRecord, test: 123, DistrictID: apiResponse?.districtId, DistrictName: currentRecord?.District });
                        }
                    }
                } catch (err) {
                    invalidRecords.push({
                        ...currentRecord,
                        errors: err.inner.map((error) => ({
                            field: error.path,
                            message: error.message
                        }))
                    });
                }
            }

            const FinialValidRecords = {
                instituteId: location?.state?.SINID?.value,
                regionId: location?.state?.SRegion?.value || 0,
                stateId: location?.state?.SStatte?.value || 0,
                schoolManagementId: SchoolMDetails.SchoolManagement,
                boardId: SchoolMDetails?.Boardofexam,
                createdBy: items?.userId,
                societyId: location?.state?.SSociety?.value || 0,
                schools: validRecords.map((SH) => ({
                    udiseCode: SH?.UDISE.toString(),
                    schoolName: SH?.SchoolName,
                    townCity: SH?.City,
                    contactName: SH?.CName,
                    contactPhone: SH?.PNumber.toString(),
                    eMail: SH?.EMail,
                    address: SH?.Address.toString(),
                    pinCode: SH?.Pincode?.toString() || "",
                    mediumId: SH?.MOI,
                    districtId: SH?.DistrictID,
                    DistrictName: SH?.DistrictName,
                    hierarchyvaluesListCSV: location?.state?.SINID?.value === 2
                        ? [location?.state?.SStatte?.value, location?.state?.SRegion?.value, SH?.DistrictID].filter(Boolean).join(",")
                        : [location?.state?.SRegion?.value, location?.state?.SStatte?.value, SH?.DistrictID].filter(Boolean).join(","),
                    stationId: 0,
                    schooltypeId: SH?.SLocation,
                    loginId: "",
                    password: "",
                }))
            }
            SetValidRecords(FinialValidRecords);
            SetInValidRecords(invalidRecords);
        }
        reader.readAsArrayBuffer(file);
    })

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            "application/vnd.ms-excel": [".xls"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
                ".xlsx",
            ],
        },
        multiple: false,
    });
    const validationSchema =
        Yup.object().shape({
            UDISE: Yup.string().trim()
                .required("School U-DISE Code is required")
                .matches(/^\d{11}$/, {
                    message: "School U-DISE Code must contain exactly 11 digits",
                    excludeEmptyString: true,
                }),
            SchoolName: Yup.string().trim().required("School Name is required")
                .max(200, "School Name cannot exceed 200 characters")
                .matches(/^[A-Za-z\s]+$/, {
                    message: "School Name must contain only alphabets",
                    excludeEmptyString: true,
                }),
            District: Yup.string().required("District is required")
                .matches(/^[A-Za-z\s]+$/, {
                    message: "District must contain only alphabets",
                    excludeEmptyString: true,
                }),
            SLocation: Yup.string().required("School Location is required"),
            City: Yup.string().required("City is required")
                .matches(/^[A-Za-z\s]+$/, {
                    message: "City must contain only alphabets",
                    excludeEmptyString: true,
                }),
            CName: Yup.string().trim().required("Contact Name is required").max(50, "Contact Name cannot exceed 50 characters")
                .matches(/^[A-Za-z.\s]+$/, {
                    message: "Contact Name must contain only alphabets",
                    excludeEmptyString: true,
                }),
            PNumber: Yup.string().trim().required("Contact Number is required")
                .matches(/^\d{10}$/, {
                    message: "Contact Number must be exactly 10 digits",
                    excludeEmptyString: true,
                }),
            EMail: Yup.string().required("Email Id is required").email("Enter a valid Email Id"),
            Address: Yup.string().trim().required("Address is required").max(200, "Address cannot exceed 200 characters"),
            Pincode: Yup.string().required("PinCode is required")
                .matches(/^\d{6}$/, {
                    message: "PinCode must be exactly 6 digits",
                    excludeEmptyString: true,
                }),
            MOI: Yup.string().required("Medium is required"),
        });
    const PostRecords = async () => {
        if (!SchoolMDetails.SchoolManagement || !SchoolMDetails?.Boardofexam) {
            notify(`${SchoolMDetails.SchoolManagement ? "Board of Exam" : "School Management "} field is required`, "warning");
            return ""
        }
        const UpdatedRecords = {
            ...ValidRecords,
            schoolManagementId: SchoolMDetails.SchoolManagement,
            boardId: SchoolMDetails?.Boardofexam,
        }
        try {
            const res = await axiosInstance.post(`/NCLAdmin/AddBulkSchools`, UpdatedRecords);
            if (res.data.errorCode === 0) {
                navigate(-1);
                notify("Schools are registered successfully", "success");
            } else {
                notify(`${res.data.insertedCount} Schools are Registered and ${ValidRecords?.schools?.length - res.data.insertedCount} schools are Not-Registered `, "warning");
            }
        }
        catch (err) {
            console.log(err)
        }
    }
    const DownloadSamplefile = () => {
        const a = document.createElement("a");
        a.href = `/SchoolsRegistration.xlsx`;
        a.download = "SchoolsRegistrationTemplate.xls";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const InvalidColumns = [
        {
            name: "School U-DISC Code", selector: "UDISE", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "UDISE")) ?
                <input type="number" className="Search p-1" value={EditForm?.UDISE} onChange={(e) => {
                    const value = e.target.value;
                    // if (/^\d{0,11}$/.test(value)) {
                         HandleInputChange(value, "UDISE");
                        //  }
                }} />
                : row.UDISE
        },
        {
            name: "School Name", selector: "SchoolName", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "SchoolName")) ?
                <input type="text" className="Search p-1" value={EditForm?.SchoolName} onChange={(e) => HandleInputChange(e.target.value.replace(/[^a-zA-Z ]/g, ""), "SchoolName")} />
                : row.SchoolName
        },
        {
            name: "District", selector: "District", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "District")) ?
                <input type="text" className="Search p-1" value={EditForm?.District} onChange={(e) => HandleInputChange(e.target.value.replace(/[^a-zA-Z ]/g, ""), "District")} />
                : row.District
        },
        {
            name: "School Loacation Rural / Urban", selector: "SLocation", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "SLocation")) ?
                <input type="text" className="Search p-1 w-75" value={EditForm?.SLocation} onChange={(e) => HandleInputChange(e.target.value.replace(/[^a-zA-Z ]/g, ""), "SLocation")} />
                : row.SLocation
        },
        {
            name: "City", selector: "City", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "City")) ?
                <input type="text" className="Search p-1" value={EditForm?.City} onChange={(e) => HandleInputChange(e.target.value.replace(/[^a-zA-Z ]/g, ""), "City")} />
                : row.City
        },
        {
            name: "Contact Name", selector: "CName", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "CName")) ?
                <input type="text" className="Search p-1" value={EditForm?.CName} onChange={(e) => HandleInputChange(e.target.value.replace(/[^a-zA-Z. ]/g, ""), "CName")} />
                : row.CName
        },
        {
            name: "Contact Number", selector: "PNumber", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "PNumber")) ?
                <input type="Number" className="Search p-1" value={EditForm?.PNumber} onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) { HandleInputChange(value, "PNumber"); }
                }}
                />
                : row.PNumber
        },
        {
            name: "Email ID", selector: "EMail", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "EMail")) ?
                <input type="email" className="Search p-1" value={EditForm?.EMail} onChange={(e) => HandleInputChange(e.target.value, "EMail")} />
                : row.EMail
        },
        {
            name: "Address", selector: "Address", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "Address")) ?
                <textarea className="Search p-1" value={EditForm?.Address} onChange={(e) => HandleInputChange(e.target.value, "Address")} />
                : row.Address
        },
        {
            name: "Pincode", selector: "Pincode", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "Pincode")) ?
                <input type="Number" className="Search p-1" value={EditForm?.Pincode} onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) { HandleInputChange(value, "Pincode"); }
                }} />
                : row.Pincode
        },
        {
            name: "Medium of Instruction", selector: "MOI", sortable: true,
            cell: (row) => (row.RowID === EditingRow?.RowID && row?.errors?.some((error) => error.field === "MOI")) ?
                <input type="text" className="Search p-1" value={EditForm?.MOI} onChange={(e) => HandleInputChange(e.target.value.replace(/[^a-zA-Z ]/g, ""), "MOI")} />
                : row.MOI
        },
        { name: "Errors", cell: (row) => (<ol style={{ color: "#FD3333" }}> {row?.errors?.map((error, index) => (<li>{error.message}</li>))}</ol>), },
        {
            name: "Action",
            cell: (row) => (
                row.RowID === EditingRow?.RowID ?
                    <div className="dflex JCCenter gap-1" >
                        <FaRegSave title="Save School Details" className="CPointer" style={{ color: "#624DE3" }} size={18} onClick={() => ValidateEditRecord()} />
                        <IoClose style={{ color: "#FD3333" }} className="CPointer" size={18} onClick={() => SetEditingRow("")} />
                    </div>
                    :
                    <div className="dflex JCCenter gap-1" >
                        {!row?.Duplicate && <FaRegEdit title="Edit School Details" className="CPointer" style={{ color: "#624DE3" }} size={18} onClick={() => HandleEdit(row)} />}
                        <RiDeleteBin5Line style={{ color: "#FD3333" }} className="CPointer" size={18} onClick={() => DeleteInvalidRecords(row)} />
                    </div>
            ),
        },
    ];
    const HandleEdit = (row) => {
        SetEditingRow(row);
        SetEditForm({ ...row });
    };
    const HandleInputChange = (e, field) => {
        SetEditForm((prev) => ({ ...prev, [field]: e, }));
    };
    const DeleteInvalidRecords = (row) => {
        SetInValidRecords((prev) => (prev || []).filter((record) => record !== row));
    }
    const DeleteValidRecords = (row) => {
        SetValidRecords((prev) => ({
            ...prev,
            schools: [...(prev?.schools || []).filter((school) => school !== row),],
        }));
    }
    const ValidateEditRecord = async () => {
        const invalidRecords = [];
        const currentRecord = { ...EditForm };
        
        try {
            await validationSchema.validate(currentRecord, { abortEarly: false });
            const errors = [];
            console.log("errors",errors)
            if (errors.length > 0) {
                console.log(currentRecord,"EditForm",EditForm)
                invalidRecords.push({
                    ...currentRecord, 
                    
                    errors: errors.map((error) => ({ field: error.path, message: error.message }))
                });
            }
            else {
                const updatedSchool = {
                    udiseCode: currentRecord.UDISE?.toString() || "",
                    schoolName: currentRecord.SchoolName,
                    townCity: currentRecord.City,
                    contactName: currentRecord.CName,
                    contactPhone: currentRecord.PNumber?.toString() || "",
                    eMail: currentRecord.EMail,
                    address: currentRecord.Address,
                    pinCode: currentRecord.Pincode?.toString() || "",
                    mediumId: currentRecord.MOI,
                    districtId: currentRecord.District,
                    schooltypeId: currentRecord.SLocation,
                    hierarchyvaluesListCSV:
                        location?.state?.SINID?.value === 2
                            ? [location?.state?.SStatte?.value, location?.state?.SRegion?.value,].filter(Boolean).join(",")
                            : [location?.state?.SRegion?.value, location?.state?.SStatte?.value,].filter(Boolean).join(","),
                    stationId: 0,
                    loginId: "",
                    password: "",
                };

                const existingSchool = (ValidRecords?.schools || []).find(
                    (school) => String(school.udiseCode).trim() === String(updatedSchool.udiseCode).trim());

                if (existingSchool) {
                    console.log("eschools")
                    const duplicateError = {
                        field: "UDISE",
                        message: `Duplicate School UDISE code is already exists in valid records.`,
                    };
                    SetEditingRow("");
                    SetEditForm({});
                    SetInValidRecords((prev) => {
                        const remainingRecords = (prev || []).filter((record) => record !== EditingRow);
                        return [...remainingRecords,
                        { ...currentRecord, Duplicate: true, errors: [duplicateError], },];
                    });
                } else {
                    console.log("eschool else")
                    const apiResponse = await CheckSchoolDetails(currentRecord?.SchoolName, currentRecord?.UDISE, currentRecord?.District);
                    if (apiResponse?.isSchoolExist === 1 || apiResponse?.districtId === 0) {
                        const errors = [apiResponse?.isSchoolExist === 1 ? { field: "Inserted", message: "School Already Exists" } : apiResponse?.districtId === 0 ? { field: "District", message: "Invalid District" } : {}]
                        SetInValidRecords((prev) =>
                            (prev || []).map((record) =>
                                record.RowID === EditingRow?.RowID
                                    ? { ...currentRecord, errors, Duplicate: apiResponse?.isSchoolExist === 1 ? true : false, }
                                    // ? { ...record, errors, Duplicate: apiResponse?.isSchoolExist === 1 ? true : false, }
                                    : record
                            )
                        );
                        SetEditingRow(null);
                        SetEditForm({});
                        return;
                        // SetInValidRecords((prev) => {
                        //     const remainingRecords = (prev || []).filter((record) => record !== EditingRow);
                        //     return [...remainingRecords,
                        //     {
                        //         ...currentRecord, Duplicate: apiResponse?.isSchoolExist === 1 ? true : false,
                        //         errors: [apiResponse?.isSchoolExist === 1 ? { field: "Inserted", message: "School Already Exists" } : apiResponse?.districtId === 0 ? { field: "District", message: "Invalid District" } : {}]
                        //     },];
                        // });
                    }

                    else if (apiResponse?.isSchoolExist === 0 && apiResponse?.districtId !== 0) {
                        SetValidRecords((prev) => ({
                            ...prev,
                            schools: [...(prev?.schools || []).filter((school) => school.udiseCode !== updatedSchool.udiseCode),
                            {
                                ...updatedSchool,
                                districtId: apiResponse?.districtId,
                                DistrictName: updatedSchool?.districtId,
                                hierarchyvaluesListCSV:
                                    location?.state?.SINID?.value === 2
                                        ? [location?.state?.SStatte?.value, location?.state?.SRegion?.value, apiResponse?.districtId].filter(Boolean).join(",")
                                        : [location?.state?.SRegion?.value, location?.state?.SStatte?.value, apiResponse?.districtId].filter(Boolean).join(","),
                            },],
                        }));
                        SetInValidRecords((prev) => (prev || []).filter((record) => record !== EditingRow));
                    }
                }
            }
        } catch (err) {
            console.log("Validation Error:", err);
            notify(<ol> {err.inner.map((error, index) => (<li key={index}>{error.message}</li>))} </ol>, "warning");
            invalidRecords.push({
                ...currentRecord,
                errors: err.inner.map((error) => ({
                    field: error.path,
                    message: error.message
                }))
            });
        }
    }

    const CheckSchoolDetails = async (SName, UDISC, District) => {
        try {
            const res = await axiosInstance.get(`/NCLAdmin/IsSchoolExists?SchoolName=${SName}&UDISECode=${UDISC}&RegionId=${location?.state?.SRegion?.value || 0}&StateId=${location?.state?.SStatte?.value}&DistrictId=${District}&InstituteID=${location?.state?.SINID?.value}`);
            return res.data?.[0];
        }
        catch (err) { console.log(err) }
    }
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="dflex " style={{ justifyContent: "flex-end" }}>
                    {Finialrecords?.length <= 0 && <div className="dflex alignitems gap-1 CPointer LinkStyles"
                        onClick={() => DownloadSamplefile()}> <MdFileDownload />Download Template</div>}
                </div>
                <div className="MainHeading mt-2 mb-2">Bulk upload of School Registrations - {location?.state?.SINID?.display},
                    {location?.state?.SINID?.value === 2 ? [location?.state?.SStatte?.display, location?.state?.SRegion?.display].filter(Boolean).join(",")
                        : [location?.state?.SRegion?.display, location?.state?.SStatte?.display].filter(Boolean).join(",")}
                </div>

                <div className="gap-3 w-100" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)" }}>
                    <div> <SManagement className="NCLDropdown w-100" LovId={47} name="SchoolManagement" Displayname="Select"
                        SOption={SchoolMDetails.SchoolManagement} onChange={(e) => StoreDetails(e, "SchoolManagement")}
                        labelname={<div className="DropdownHeader"> School Management <span>*</span> </div>} /> </div>

                    <div> <SManagement className="NCLDropdown w-100" LovId={57} name="Boardofexam" Displayname="Select"
                        onChange={(e) => StoreDetails(e, "Boardofexam")} SOption={SchoolMDetails?.Boardofexam}
                        labelname={<div className="DropdownHeader "> Board Of Examination/Affiliation <span>*</span> </div>} /></div>
                </div>

                <div className="mt-2 dflex JCCenter alignitems flexd-column p-3">
                    <div className="dflex alignitems JCCenter gap-1">
                        <RiFileExcel2Fill fontSize={60} color="#107c41" />
                        <div
                            {...getRootProps()} className="CPointer dflex alignitems JCCenter p-2 w-100"
                            style={{
                                border: "2px dashed #1436a5", textAlign: "center", borderRadius: "5px",
                                backgroundColor: "#e0e7ff",
                            }} >
                            <input {...getInputProps()} />
                            {SFName ? <p className="m-0">{SFName}</p> : <p className="m-0">Select File</p>}
                        </div>
                    </div>
                    <p className="m-0">Select or Drag and drop file</p>
                </div>
                <div className="BlinkingText" style={{ color: "#4e4eff" }}><b>Note :</b> The Schools will be uploaded under '{location?.state?.SINID?.display}' Institute
                    {location?.state?.SINID?.value === 2
                        ? `,'${location?.state?.SStatte?.display}' State for the Region '${location?.state?.SRegion?.display}'`
                        : `${location?.state?.SRegion?.display ? `,'${location?.state?.SRegion?.display}' Region` : ""} for the State '${location?.state?.SStatte?.display}'`
                    }
                </div>

                {InValidRecords?.length > 0 && <>
                    <div className="SubHeading mt-2"> Invalid Records</div>
                    <DataTable data={InValidRecords} columns={InvalidColumns} className="NCLDataTable Card mt-2" DisplaySearch={true} /> </>}

                {ValidRecords?.schools?.length > 0 && <>
                    <div className="dflex JSBetween alignitems mt-4">
                        <div className="SubHeading"> Valid Records</div>
                        {SFName && ValidRecords?.schools?.length > 0 && <div className="dflex alignitems JCCenter">
                            <button className="Buttons" onClick={() => PostRecords()}>Upload the schools</button>
                        </div>} </div>
                    <div className="NCLDataTable Card mt-2">
                        <table className="Data-Table">
                            <thead>
                                <tr>
                                    <th>S.No</th> <th>School U-DISC Code</th> <th>School Name</th> <th>District</th>
                                    <th>School Loacation Rural / Urban</th> <th>City</th> <th>Contact Name</th>
                                    <th>Contact Number</th> <th>Email ID</th> <th>Address</th> <th>Pincode</th>
                                    <th>Medium of Instruction</th> <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ValidRecords?.schools?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td> <td>{item.udiseCode}</td> <td>{item.schoolName}</td>
                                        <td>{item.DistrictName}</td> <td>{item.schooltypeId}</td> <td>{item.townCity}</td>
                                        <td>{item.contactName}</td> <td>{item.contactPhone}</td> <td>{item.eMail}</td>
                                        <td>{item.address}</td> <td>{item.pinCode}</td> <td>{item.mediumId}</td>
                                        <td> <div className="d-flex justify-content-center">
                                            <RiDeleteBin5Line style={{ color: "#FD3333" }} className="CPointer" size={18} onClick={() => DeleteValidRecords(item)} />
                                        </div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>}
            </div>
        </>
    )
}
export default SchoolBulk;